import { Crown, Gem, Circle } from 'lucide-react';

export interface SubCategory {
  id: string;
  name: string;
  parentCategoryId: string;
  searchKeyword: string;
}

export interface MainCategory {
  id: string;
  name: string;
  icon: any;
  dbId: string;
}

export const MAIN_CATEGORIES: MainCategory[] = [
  { id: 'all', name: 'All Products', icon: Circle, dbId: 'all' },
  { id: 'gold', name: 'Gold Jewellery', icon: Crown, dbId: '1' },
  { id: 'silver', name: 'Silver Jewellery', icon: Gem, dbId: '2' },
];

export const SUB_CATEGORIES: Record<string, SubCategory[]> = {
  gold: [
    { id: 'gold-coins', name: 'Gold Coins', parentCategoryId: '1', searchKeyword: 'coin' },
    { id: 'gold-rings', name: 'Gold Rings', parentCategoryId: '1', searchKeyword: 'ring' },
    { id: 'gold-necklaces', name: 'Gold Necklaces', parentCategoryId: '1', searchKeyword: 'necklace' },
    { id: 'gold-earrings', name: 'Gold Earrings', parentCategoryId: '1', searchKeyword: 'earring' },
  ],
  silver: [
    { id: 'silver-coins', name: 'Silver Coins', parentCategoryId: '2', searchKeyword: 'coin' },
    { id: 'silver-gifts', name: 'Silver Gifts', parentCategoryId: '2', searchKeyword: 'gift' },
    { id: 'silver-jewelry', name: 'Silver Jewellery', parentCategoryId: '2', searchKeyword: 'jewelry' },
  ],
};

// Helper to find subcategory by ID
export const findSubCategory = (id: string): SubCategory | undefined => {
  // Handle compound IDs (e.g. "gold:gold-coins" -> "gold-coins")
  const actualId = id.includes(':') ? id.split(':')[1] : id;
  
  for (const parentId in SUB_CATEGORIES) {
    const sub = SUB_CATEGORIES[parentId].find(s => s.id === actualId);
    if (sub) return sub;
  }
  return undefined;
};
